/**
 * Created by evgenijsenkevic on 25.09.2024
 */

cc.Flicker = function (duration, color, reverse) {
    cc.ActionInterval.call(this, duration);
    this._color = color;
    this._reverse = reverse;
};

cc.Flicker.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Flicker,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        const program = cleverapps.Shaders.getProgram(cleverapps.Shaders.FLICKER_SHADER_KEY);
        if (!program) {
            return;
        }

        if (!this.target.normalShader) {
            this.target.normalShader = this.target.getShaderProgram();
            this.target.setShaderProgram(program);
        }

        this._shader = this.target.getShaderProgram();
    },

    update: function (dt) {
        if (!this._shader) {
            return;
        }

        this._shader.use();

        if (this._reverse) {
            dt = 1 - dt;
        }

        this._shader.setUniformLocationWith1f("sineTime", dt);
        this._shader.setUniformLocationWith3f("flickColor", this._color[0], this._color[1], this._color[2]);
    },

    _finalize: function () {
        this.target.normalShader && this.target.setShaderProgram(this.target.normalShader);
        delete this.target.normalShader;
    },

    stop: function () {
        this.target.normalShader && this.target.setShaderProgram(this.target.normalShader);
        delete this.target.normalShader;
        delete this._shader;

        cc.ActionInterval.prototype.stop.call(this);
    }
});